import NavigationPage from './NavigationPage.vue';
import CleanPage from './CleanPage.vue';

export default {
  install(Vue) {
    Vue.component('NavigationPage', NavigationPage);
    Vue.component('CleanPage', CleanPage);
  }
};